export default "https://cdn-static.gokick.com/assets/c0e4f86ff5da21e4b09546702d214e718bb56dad/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";